import ExcelJS from 'exceljs';
import TGButton from 'src/components/ui/TGButton';
import { DownloadIcon } from 'src/components/ui-icons/upload';

interface ExportToExcelGOPProps {
  data: any[];
}

const ExportToExcelGOP: React.FC<ExportToExcelGOPProps> = ({ data }) => {
  const exportExcelFile = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('План действий GOP');

      sheet.properties.defaultRowHeight = 45;

      sheet.columns = [
        { header: 'Направление', key: 'direction', width: 25 },
        { header: 'Блок', key: 'block', width: 25 },
        { header: 'Требование', key: 'demand', width: 50 },
        { header: 'Фокусный', key: 'focus', width: 15 },
        { header: 'Дата создания', key: 'created', width: 15 },
        { header: 'Описание действий', key: 'description', width: 50 },
        { header: 'Ответственный', key: 'responsible', width: 25 },
        { header: 'Срок выполнения', key: 'deadline', width: 15 },
        { header: 'Статус', key: 'status', width: 15 },
        { header: 'Название совещания', key: 'meetingTitle', width: 50 },
      ];

      if (data && data.length > 0) {
        data.forEach((item) => {
          const descriptionText = item.Description ? item.Description.replace(/<[^>]*>/g, '') : '';

          sheet.addRow({
            direction: item.directionTitle || '-',
            block: item.blockTitle || '-',
            demand: item.demandTitle || '-',
            focus: item.IsFocal ? 'Да' : 'Нет',
            created: item.Created ? item.Created.format('DD.MM.YYYY') : '',
            description: descriptionText,
            responsible: item.Responsible?.Name || '',
            deadline: item.DateForDone ? item.DateForDone.format('DD.MM.YYYY') : '',
            status: item.Status?.Title || '',
            meetingTitle: item.Meeting?.Title || '',
          });
        });
      }

      sheet.getRow(1).font = {
        size: 12,
        bold: true,
        color: { argb: '000000' },
      };

      sheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };

          if (rowNumber > 1) {
            cell.font = {
              italic: true,
              size: 11,
            };
          }

          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
            wrapText: true,
          };
        });
      });

      sheet.columns.forEach((column) => {
        if (column.header) {
          column.width = (column.width as number) + 2;
        }
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'План_действий_GOP.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Ошибка при экспорте файла:', error);
    }
  };

  return (
    <div>
      <TGButton onClick={exportExcelFile} color='white' disabled={!data || data.length === 0}>
        <DownloadIcon />
      </TGButton>
    </div>
  );
};

export default ExportToExcelGOP;